// extracted by mini-css-extract-plugin
export var dividerLine = "_7j-3";
export var itemImage = "_7j-9";
export var lightDivider = "_7j-4";
export var modalContent = "_7j-5";
export var modalContentCompact = "_7j-6";
export var productCard = "_7j-a";
export var productImage = "_7j-b";
export var productImageCompact = "_7j-7";
export var productImagePlaceholder = "_7j-c";
export var productImagePlaceholderCompact = "_7j-8";
export var progressBarBackground = "_7j-1";
export var progressBarContainer = "_7j-0";
export var progressBarFill = "_7j-2";